import userStateService from "@/common/userState.service";

export const SET_STOCK_CONTEXT = "setStockContext";
export const INIT_STOCK_CONTEXT = "initStockContext";

const STORAGE_KEY = "stock.context";

const normalizeIds = (value) => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((item) => item !== null && item !== undefined && item !== "");
};

const storedContext = userStateService.getState(STORAGE_KEY, {});

const state = {
  organization_ids: normalizeIds(storedContext.organization_ids),
  warehouse_ids: normalizeIds(storedContext.warehouse_ids),
  version: 0,
};

const getters = {
  stockContextOrganizationIds(state) {
    return state.organization_ids;
  },
  stockContextWarehouseIds(state) {
    return state.warehouse_ids;
  },
  stockContextVersion(state) {
    return state.version;
  },
  stockContextFilterParams(state) {
    return {
      organization_ids: state.organization_ids,
      warehouse_ids: state.warehouse_ids,
    };
  },
};

const actions = {
  [INIT_STOCK_CONTEXT]({ commit }) {
    commit("setContext", userStateService.getState(STORAGE_KEY, {}));
  },
  [SET_STOCK_CONTEXT]({ commit }, payload) {
    commit("setContext", payload || {});
  },
};

const mutations = {
  setContext(state, payload) {
    state.organization_ids = normalizeIds(payload.organization_ids);
    state.warehouse_ids = normalizeIds(payload.warehouse_ids);
    state.version += 1;

    userStateService.setState(STORAGE_KEY, {
      organization_ids: state.organization_ids,
      warehouse_ids: state.warehouse_ids,
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
